// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel-module_carousel__2QlCi","wrapper":"Carousel-module_wrapper__3wDdz","item":"Carousel-module_item__191Iv"};